var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loaded),
      expression: "loaded"
    }],
    staticClass: "order-detail"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "shai_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.order.product_pkg_title))]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("￥ "), _c('span', [_vm._v(_vm._s(_vm.price[0]))]), _vm._v(" " + _vm._s(_vm.price[1]))])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_vm._v("\n\t\t\t\t客户姓名"), _c('span', {
    staticClass: "ml15 black"
  }, [_vm._v(_vm._s(_vm.name_mask))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "letter"
  }, [_vm._v("咨询顾问")]), _c('span', {
    staticClass: "ml15 black"
  }, [_vm._v(_vm._s(_vm.order.staff_user_name) + "（" + _vm._s(_vm.order.staff_dept_name) + "）")])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t支付方式"), _c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.order.paid_vendor_title))])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t付款时间"), _c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.order.paid_time))])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t订单编号"), _c('span', {
    staticClass: "ml15"
  }, [_vm._v(_vm._s(_vm.order.order_no))])]), _vm._v(" "), _c('div', {
    staticClass: "divider-line"
  })]), _vm._v(" "), (_vm.tips.length > 0) ? _c('div', {
    staticClass: "bottom"
  }, [_c('div', [_vm._v("温馨提示")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('div')]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shai_colourbar"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/shai_colourbar.png"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner_logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/shai_logo.png"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-0cd93a29","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/message/MessageShow.vue
// module id = 226
// module chunks = 0